<template>
  <div class="verification">

    <div class="container-header">
      <div class="container-header__title"> {{ i18n.lbl_verification() }}</div>
    </div>

    <user-type-selector v-if="!selectedUserType" @onVerification="handleUserType"/>

    <template v-if="selectedUserType">

      <template v-if="accountState === ACCOUNT_STATES.approved && !showForm &&
      (accountKycLatestRequest.accountTypeToSet === userTypes.general ||
       accountKycLatestRequest.accountTypeToSet === userTypes.syndicate)">
        <approved-banner :userType="selectedUserType" />
      </template>

      <template v-if="accountState === ACCOUNT_STATES.pending">
        <state-banner/>

        <template v-if="selectedUserType === userTypes.general">
          <individual-form/>
        </template>

        <template v-if="selectedUserType === userTypes.syndicate">
          <syndicate-form/>
        </template>

      </template>

      <template v-if="accountState === ACCOUNT_STATES.rejected">
        <div class="container container_40 banner">
          <div class="verification__card-message">
            <md-icon class="md-size-4x verification__card-message-icon">warning</md-icon>
            <div class="banner__title text_large">{{i18n.kyc_rejected_title()}}</div>
            <p class="banner__description" v-html="i18n.kyc_rejected_msg_html({ reason: accountKycLatestRequest.rejectReason }) "></p>
          </div>

          <div class="btn-wrap">
            <md-button class="btn md-primary" @click="showForm = true">{{ i18n.lbl_edit_details() }}</md-button>
          </div>
        </div>
      </template>

      <template v-if="accountState === ACCOUNT_STATES.nil ||
      showForm ||
      accountKycLatestRequest.accountTypeToSet === userTypes.not_verified"> <!-- TODO: check this template. Maybe this is a repetition of the template on line 16 -->

        <template v-if="selectedUserType === userTypes.general">
          <individual-form />
        </template>

        <template v-else-if="selectedUserType === userTypes.syndicate">
          <syndicate-form />
        </template>

      </template>
    </template>
  </div>
</template>
<script>
  import IndividualForm from './Verification.Individual'
  import SyndicateForm from './Verification.Syndicate'
  import StateBanner from './Verification.StateBanner'
  import ApprovedBanner from './Verification.ApprovedBanner'
  import UserTypeSelector from './Verification.Selector'

  import { i18n } from '@js/i18n'
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { userTypes, ACCOUNT_TYPES, ACCOUNT_STATES } from '@const'

  export default {
    name: 'verification-make',
    components: {
      IndividualForm,
      SyndicateForm,
      ApprovedBanner,
      StateBanner,
      UserTypeSelector
    },
    data: _ => ({
      selectedUserType: '',
      ACCOUNT_TYPES,
      ACCOUNT_STATES,
      userTypes,
      showForm: false,
      i18n
    }),
    async created () {
      await this.reset()
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountLatestBlobId,
        vuexTypes.accountState,
        vuexTypes.accountType,
        vuexTypes.accountTypeI,
        vuexTypes.accountKycData,
        vuexTypes.accountKycDocuments,
        vuexTypes.accountLatestKycLevel,
        vuexTypes.accountKycLatestRequest
      ])
    },
    methods: {
      ...mapActions({
        loadAccount: vuexTypes.GET_ACCOUNT_DETAILS,
        loadUser: vuexTypes.GET_USER_DETAILS,
        loadKycRequests: vuexTypes.GET_ACCOUNT_KYC_REQUESTS,
        loadKycData: vuexTypes.GET_ACCOUNT_KYC_DATA
      }),

      async reset () {
        await this.loadKycRequests()
        await this.loadAccount()

        if (!this.accountLatestBlobId) {
          return
        }

        const typeToSet = this.accountKycLatestRequest.accountTypeToSetI
        switch (this.accountLatestKycLevel) {
          case 0:
            if (typeToSet === this.ACCOUNT_TYPES.syndicate) {
              await this.loadKycData({
                blobId: this.accountLatestBlobId,
                type: this.ACCOUNT_TYPES.syndicate
              })
              this.selectedUserType = this.userTypes.syndicate
            } else if (typeToSet === this.ACCOUNT_TYPES.general) {
              await this.loadKycData({
                blobId: this.accountLatestBlobId,
                type: this.ACCOUNT_TYPES.general
              })
              this.selectedUserType = userTypes.general
            } else {
              await this.loadKycData({
                blobId: this.accountLatestBlobId,
                type: this.ACCOUNT_TYPES.general
              })
              this.selectedUserType = ''
            }
            break
          case 1:
            await this.loadKycData({
              blobId: this.accountLatestBlobId,
              type: ACCOUNT_TYPES.general
            })
            this.selectedUserType = userTypes.general
            break
          default:
            this.selectedUserType = ''
        }
      },

      handleUserType (type) {
        this.selectedUserType = type
      },

      handleUpdate (type) {
        this.selectedUserType = type
        this.showForm = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './verification.scss';
  @import '~scss/variables';
  @import '~scss/mixins';

  .verification {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
  }

  /*.verification__card-message {
    display: flex;
    flex-direction: column;
    text-align: center;

    @include respond-to(medium) {
      padding: 0 .625rem;
    }
  }

  .verification__card-message-title {
    margin-top: 1rem;
  }

  .verification__card-action--to-right:first-child {
    margin-left: auto;
  }

  .verification__card-message-icon {
    .verification__card--pending & {
      color: $blue;
    }

    .verification__card--rejected & {
      color: $red;
    }

    .verification__card--approved & {
      color: $green;
    }
  }

  .verification__card--rejected {
    align-self: center;
  }*/
</style>



// WEBPACK FOOTER //
// src/vue/app/verification/make/Verification.Make.vue